import { useSelector } from 'react-redux';
import { IState } from 'redux/reducers';

class UndefinedOrganization extends Error {
  constructor() {
    super(`Undefined current organization`);
  }
}

class UndefinedSubscription extends Error {
  constructor() {
    super(`Undefined current subscription`);
  }
}

export function useCurrentOrganization() {
  const authState = useSelector((state: IState) => state.auth);
  if (!authState.currentOrganization) {
    throw new UndefinedOrganization();
  }
  return authState.currentOrganization;
}

export function useCurrentSubscription() {
  const authState = useSelector((state: IState) => state.auth);
  if (!authState.currentSubscription) {
    throw new UndefinedSubscription();
  }
  return authState.currentSubscription;
}

export function useCurrentOrganizations() {
  const authState = useSelector((state: IState) => state.auth);
  return authState.organizations;
}
